import React, { useState } from 'react';
import { useAuth } from '../utils/AuthContext';
import apiService from '../services/apiService';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { setUserPermissions } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await apiService.post('/auth/user-login', {
        emailAddress: email,
        password: password
      });

      console.log('Login response:', response); // Debug log
      
      // Store permissions in AuthContext
      setUserPermissions(response);
      
    } catch (err) {
      console.error('Login error:', err); // Debug log
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: 'var(--cbre-bg-primary)'
    }}>
      <div style={{
        backgroundColor: 'var(--cbre-bg-secondary)',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '400px',
        maxWidth: '90vw'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: 'var(--cbre-text)' }}>
          Login to CBREX Admin
        </h2>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '5px', 
              color: 'var(--cbre-text)',
              fontWeight: 'bold'
            }}>
              Email Address:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid var(--cbre-border)',
                borderRadius: '4px',
                backgroundColor: 'var(--cbre-bg-primary)',
                color: 'var(--cbre-text)'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '5px', 
              color: 'var(--cbre-text)',
              fontWeight: 'bold'
            }}>
              Password:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid var(--cbre-border)',
                borderRadius: '4px',
                backgroundColor: 'var(--cbre-bg-primary)',
                color: 'var(--cbre-text)'
              }}
            />
          </div>
          
          {error && (
            <div style={{
              color: 'red',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}
          
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: loading ? 'var(--cbre-bg-secondary)' : 'var(--cbre-primary)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
